import styled from "@emotion/styled";

export const Rotate = styled.span`
  padding-bottom: 0;
  display: flex;
  align-items: center;
  transition: transform 0.3s ease;
  transform: ${p => (p.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  transform-origin: center calc(50% + 1px);
  ${props => props.addStyles}
`;

// example
// const addStyles = css`
//   color: red;
//   font-size: 16px;

//   @media (min-width: ${p => p.theme.screenSizes.mdMax}) {
//     color: blue;
//     font-size: 20px;
//   }
// `;
